import dayjs from 'dayjs';

export function getTodayEndDate() {
  const today = dayjs().tz().endOf('day').tz();
  return today;
}
